export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

type FontFace = { family: string; weights: readonly number[]; fallback: 'serif' | 'sans-serif' };

/** Curated Google Font pairings. Templates only ever load the two families of the chosen pairing. */
export const FONT_PAIRINGS = {
    modern: {
        label: 'Modern',
        heading: { family: 'Inter', weights: [700], fallback: 'sans-serif' },
        body: { family: 'Inter', weights: [400, 600], fallback: 'sans-serif' },
    },
    classic: {
        label: 'Classic',
        heading: { family: 'Playfair Display', weights: [700], fallback: 'serif' },
        body: { family: 'Source Sans 3', weights: [400, 600], fallback: 'sans-serif' },
    },
    friendly: {
        label: 'Friendly',
        heading: { family: 'Nunito', weights: [800], fallback: 'sans-serif' },
        body: { family: 'Nunito', weights: [400, 700], fallback: 'sans-serif' },
    },
    bold: {
        label: 'Bold',
        heading: { family: 'Oswald', weights: [600], fallback: 'sans-serif' },
        body: { family: 'Open Sans', weights: [400, 600], fallback: 'sans-serif' },
    },
    elegant: {
        label: 'Elegant',
        heading: { family: 'Cormorant Garamond', weights: [600], fallback: 'serif' },
        body: { family: 'Lato', weights: [400, 700], fallback: 'sans-serif' },
    },
    clean: {
        label: 'Clean',
        heading: { family: 'Poppins', weights: [600], fallback: 'sans-serif' },
        body: { family: 'Poppins', weights: [400, 500], fallback: 'sans-serif' },
    },
    editorial: {
        label: 'Editorial',
        heading: { family: 'Fraunces', weights: [700], fallback: 'serif' },
        body: { family: 'Inter', weights: [400, 600], fallback: 'sans-serif' },
    },
    warm: {
        label: 'Warm',
        heading: { family: 'Merriweather', weights: [700], fallback: 'serif' },
        body: { family: 'Merriweather Sans', weights: [400, 700], fallback: 'sans-serif' },
    },
} as const satisfies Record<string, { label: string; heading: FontFace; body: FontFace }>;

export type FontPairingId = keyof typeof FONT_PAIRINGS;
export const FONT_PAIRING_IDS = Object.keys(FONT_PAIRINGS) as [FontPairingId, ...FontPairingId[]];

export const CORNER_STYLES = ['square', 'rounded', 'pill'] as const;

/** Validated by `themeSchema` in schemas.ts. */
export type Theme = {
    background: string;
    primary: string;
    accent: string;
    fontPairing: FontPairingId;
    corners: (typeof CORNER_STYLES)[number];
};

export const DEFAULT_THEME: Theme = {
    background: '#FFFFFF',
    primary: '#2557D6',
    accent: '#E8A317',
    fontPairing: 'modern',
    corners: 'rounded',
};
